export default __webpack_public_path__ + "static/media/bg.8502c17b.png";